import { type StoreApi, type UseBoundStore } from 'zustand';
import { shallow } from 'zustand/shallow';

export const useZustandStore = <T, R extends Partial<T>>(
  store: UseBoundStore<StoreApi<T>>,
  flatMapper: (store: T) => R,
) => store(state => flatMapper(state), shallow);
